function openPopup() {
var popup = document.getElementById("popup");
popup.style.display = "block";
}
function closePopup() {
var popup = document.getElementById("popup");
popup.style.display = "none";
}

function validateForm(event) {
    const form = document.getElementById('CustomerForm')
    const checkbox = document.getElementById('acceptance')

    if (!checkbox.checked) {
        alert('Debes aceptar los términos y condiciones.')
        event.preventDefault() // Evita el envío del formulario
        return false
    }
}

document.addEventListener("DOMContentLoaded", function () {

    // Verifica si el popup ya fue mostrado
    if (!localStorage.getItem("popupShown")) {

        setTimeout(function () {
            document.getElementById("popup").style.display = "block";
            console.log("Popup mostrado.");
            localStorage.setItem("popupShown", "true");
        }, 5000); // Se abre a los 5 segundos

    }
});
